import { render } from "./CarHealth.vue?vue&type=template&id=3ac11684&scoped=true"
import script from "./CarHealth.vue?vue&type=script&lang=js"
export * from "./CarHealth.vue?vue&type=script&lang=js"

import "./CarHealth.vue?vue&type=style&index=0&id=3ac11684&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ac11684"]])

export default __exports__